var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('loader',{attrs:{"object":"#A40802","color1":"#ffffff","color2":"#0066B3","size":"5","speed":"2","bg":"#F9F9F9","objectbg":"#999793","opacity":"100","name":"circular"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }